import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetPersistedCommunitySettings($id: ID!, $locale: String) {
    community(id: $id, locale: $locale) {
      id
      settings {
        name
        pricing {
          id
          type
          currency
          amount
        }
        industry {
          id
        }
        validationCode
        defaultLanguage
        allowTransfer
        hasMultipleTargets
        agentsGuuruHotTransfers
        partnerFont
        partnerColor
        invitationHeroUrl
        recruiting
      }
    }
  }
`);
